import React from "react";
import { useDispatch } from "react-redux";
import {
  decreaseCartQunatity,
  deleteProductCard,
  increaseCartQunatity,
} from "../../Redux/Product/action";

export default function CartItem({ products }) {
  const dispatch = useDispatch();
  const handleIncreseQuntity = (item) => {
    dispatch(increaseCartQunatity(item));
  };
  const handleDecreseQuntity = (item) => {
    dispatch(decreaseCartQunatity(item));
  };
  const handleDeleteCart = (item) => {
    dispatch(deleteProductCard(item));
  };
  return (
    <>
      <div className="space-y-6">
        {/* <!-- Cart Item --> */}
        {products.length > 0 ? (
          products.map((item, index) => (
            <div key={`${item?.productId}_${index}`} className="cartCard">
              <div className="flex items-center col-span-6 space-x-6">
                {/* <!-- cart image --> */}
                <img
                  className="lws-cartImage"
                  src={item.imageUrl}
                  alt="product"
                />
                {/* <!-- cart item info --> */}
                <div className="space-y-2">
                  <h4 className="lws-cartName">{item.productName}</h4>
                  <p className="lws-cartCategory">{item?.category}</p>
                  <p>
                    BDT <span className="lws-cartPrice">{item?.price}</span>
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
                {/* <!-- amount buttons --> */}
                <div className="flex items-center space-x-4">
                  <button
                    onClick={() => handleIncreseQuntity(item)}
                    className="lws-incrementQuantity"
                    disabled={item?.quantity <= 0 && true}
                  >
                    <i className="text-lg fa-solid fa-plus"></i>
                  </button>
                  <span className="lws-cartQuantity">
                    {item?.totalSelectQuntity}
                  </span>
                  <button
                    onClick={() => handleDecreseQuntity(item)}
                    className="lws-decrementQuantity"
                    disabled={item?.totalSelectQuntity <= 1 && true}
                  >
                    <i className="text-lg fa-solid fa-minus"></i>
                  </button>
                </div>
                {/* <!-- price --> */}
                <p className="text-lg font-bold">
                  BDT{" "}
                  <span className="lws-calculatedPrice">
                    {+item?.price * +item?.totalSelectQuntity}
                  </span>
                </p>
              </div>
              {/* <!-- delete button --> */}
              <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
                <button
                  onClick={() => handleDeleteCart(item)}
                  className="lws-removeFromCart"
                >
                  <i className="text-lg text-red-400 fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
          ))
        ) : (
          <div>No Cart Found</div>
        )}

        {/* <!-- Cart Items Ends --> */}
      </div>
    </>
  );
}
